<template>
  <div class="login">
    <h2 class="plat-title">权限管理系统</h2>
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
<!--          <p class="login-tip">输入任意用户名和密码即可</p>-->
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
  import LoginForm from '@com/app/LoginForm.vue'
  import { mapActions } from 'vuex'
  export default {
    components: {
      LoginForm
    },
    methods: {
      ...mapActions([
        'handleLogin',
        'getUserInfo'
      ]),
      handleSubmit ({ userName, password }) {
        this.handleLogin({ userName, password }).then(res => {
          this.$router.push({
            name: this.$config.HOME_NAME
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .login{
    width: 100%;
    height: 100%;
    background-image: url('../../assets/images/login_bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
    .plat-title {
      color: #ffffff;
      font-size: 32px;
      display: inline-block;
      /*text-align: center;*/
      /*padding-top: 10%;*/
      position: absolute;
      right: 160px;
      top: 28%;
      transform: translateY(-60%);
      width: 310px;
    }
    &-con{
      position: absolute;
      right: 160px;
      top: 50%;
      transform: translateY(-60%);
      width: 310px;
      /*height: 200px;*/
      /*top:0;*/
      /*right: 0;*/
      /*bottom: 0;*/
      /*left: 0;*/
      /*margin: auto;*/
      &-header{
        font-size: 16px;
        font-weight: 300;
        text-align: center;
        /*padding: 30px 0;*/
      }
      .form-con{
        /*padding: 10px 0 0;*/
      }
      .login-tip{
        font-size: 10px;
        text-align: center;
        color: #c3c3c3;
      }
    }
  }
</style>
